import { Title } from '@mantine/core';
// components
import type {
    TSessionByChannel,
    TSessionByType,
    TSessionSummary
} from '@newo/api/gateway';
import ByChannel from '@/pages/Report/components/SessionDistribution/components/ByChannel';
import ByTime from '@/pages/Report/components/SessionDistribution/components/ByTime';
import ByType from '@/pages/Report/components/SessionDistribution/components/ByType';
// utils

interface SessionDistributionProps {
    byChannel: TSessionByChannel[];
    byType: TSessionByType;
    summary: TSessionSummary;
}

const SessionDistribution = ({
    byChannel,
    summary,
    byType
}: SessionDistributionProps) => {
    return (
        <div className="space-y-4">
            <Title order={3} size="h3">
                Session Distribution
            </Title>
            <div className="grid md:grid-cols-2 gap-8">
                <ByType className="col-span-2" data={byType} />
                <ByTime
                    className="col-span-2 md:col-span-1"
                    data={summary.sessions}
                />
                <ByChannel
                    className="col-span-2 md:col-span-1"
                    data={byChannel}
                />
            </div>
        </div>
    );
};

export default SessionDistribution;
